import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ProtectRoute, RoleBasedRedirect } from "lib/components/ui";
import { ROUTE_PATH } from "./router-constant/router.constant";
import { 
  AuthRegisterPage,
  UserListPage, 
  UserNewPage, 
  UserEditPage,
  MySubscriptionPage,
  PurchaseSubscriptionPage,
  SubscriptionListPage,
  PaymentReceiptListPage,
  VpnSettingsPage,
  GuidancePage,
} from "pages";
import { LayoutMain } from "lib/components/layout";
import { AuthLoginNewComponent } from "pages/auth/login/auth-login-new.component";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectRoute>
              <RoleBasedRedirect />
            </ProtectRoute>
          }
        ></Route>
        <Route
          path={ROUTE_PATH.auth.login.path}
          element={
            <ProtectRoute protectUnAuthorized={true}>
              <AuthLoginNewComponent />
            </ProtectRoute>
          }
        ></Route>
        <Route
          path={ROUTE_PATH.auth.register.path}
          element={
            <ProtectRoute protectUnAuthorized={true}>
              <AuthRegisterPage />
            </ProtectRoute>
          }
        ></Route>
        <Route
          path="/"
          element={
            <ProtectRoute>
              <LayoutMain />
            </ProtectRoute>
          }
        >
          {/* User Management - Admin Only */}
          <Route
            path={ROUTE_PATH.users.list.path}
            element={
              <ProtectRoute allowedRoles={["admin"]}>
                <UserListPage />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path={ROUTE_PATH.users.new.path}
            element={
              <ProtectRoute allowedRoles={["admin"]}>
                <UserNewPage />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path={ROUTE_PATH.users.edit.path}
            element={
              <ProtectRoute allowedRoles={["admin"]}>
                <UserEditPage />
              </ProtectRoute>
            }
          ></Route>

          {/* Subscription Management */}
          <Route
            path={ROUTE_PATH.subscriptions.list.path}
            element={
              <ProtectRoute allowedRoles={["admin"]}>
                <SubscriptionListPage />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path={ROUTE_PATH.subscriptions.mySubscription.path}
            element={
              <ProtectRoute allowedRoles={["user"]}>
                <MySubscriptionPage />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path={ROUTE_PATH.subscriptions.purchase.path}
            element={
              <ProtectRoute allowedRoles={["user"]} requireNoSubscription={true}>
                <PurchaseSubscriptionPage />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path={ROUTE_PATH.subscriptions.guidance.path}
            element={
              <ProtectRoute>
                <GuidancePage />
              </ProtectRoute>
            }
          ></Route>

          {/* Payment Receipts - Admin Only */}
          <Route
            path={ROUTE_PATH.paymentReceipts.list.path}
            element={
              <ProtectRoute allowedRoles={["admin"]}>
                <PaymentReceiptListPage />
              </ProtectRoute>
            }
          ></Route>

          {/* VPN Settings - Admin Only */}
          <Route
            path={ROUTE_PATH.settings.vpn.path}
            element={
              <ProtectRoute allowedRoles={["admin"]}>
                <VpnSettingsPage />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path={ROUTE_PATH.settings.payment.path}
            element={<Navigate to={`${ROUTE_PATH.settings.vpn.path}?tab=v2ray`} replace />}
          ></Route>
          <Route
            path={ROUTE_PATH.manualCategories.list.path}
            element={<Navigate to={`${ROUTE_PATH.settings.vpn.path}?tab=vmess&subtab=tariffs`} replace />}
          ></Route>
          <Route
            path={ROUTE_PATH.vpnAccounts.list.path}
            element={<Navigate to={`${ROUTE_PATH.settings.vpn.path}?tab=vmess&subtab=accounts`} replace />}
          ></Route>
        </Route>
        <Route
          path="*"
          element={
            <ProtectRoute>
              <Navigate to="/" />
            </ProtectRoute>
          }
        ></Route>
      </Routes>
    </BrowserRouter>
  );
};
